import React, { useState } from "react";
import { StateMachineProvider, createStore } from "little-state-machine";

import AttributesValueStep from "../pages/Directories/AttributesValueStep";
import GeneralInfoStep from "../pages/Directories/GeneralInfoStep";
import PermissionsStep from "../pages/Directories/PermissionsStep";

createStore({ data: {} });
window.sessionStorage.clear();

const DirectoryStepForm = ({ id, formType }) => {
  const [step, setStep] = useState(1);
  const [itemId, setItemId] = useState(id);
  const [stepLength, setStepLength] = useState(3);

  const nextStep = responseId => {
    setStep(step + 1);
    setItemId(responseId);
  };

  const previousStep = responseId => {
    setStep(step - 1);
    setItemId(responseId);
  };

  switch (step) {
    case 1:
      return (
        <GeneralInfoStep
          id={itemId}
          formType={formType}
          nextStepChange={nextStep}
          stepLength={stepLength}
        />
      );
    case 2:
      return (
        <StateMachineProvider>
          <AttributesValueStep
            id={itemId}
            formType={formType}
            previousStepChange={previousStep}
            nextStepChange={nextStep}
            stepLength={stepLength}
          />
        </StateMachineProvider>
      );
    case 3:
      return (
        <PermissionsStep
          id={itemId}
          formType={formType}
          previousStepChange={previousStep}
          stepLength={stepLength}
        />
      );
    default:
      return null;
  }
};

export default DirectoryStepForm;
